import { DealerBusinessService } from './../../business-services/dealer.service';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EditDealerGuard  {
    constructor(
        private dealerBusinessService: DealerBusinessService,
        private router: Router
    ) {}

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
        if (this.dealerBusinessService.dealerId) {
            return true;
        }
        return this.router.createUrlTree(['/dealer']);
    }
}
